import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { JobEnqueueResultDto, PagedResult, QueryOptions, ThresholdNotificationDto } from '../lib/types';

function toQuery(options: QueryOptions, groupId?: number): string {
  const p = new URLSearchParams();
  if (options.page) p.set('page', String(options.page));
  if (options.pageSize) p.set('pageSize', String(options.pageSize));
  if (options.filter) p.set('filter', options.filter);
  if (groupId) p.set('groupId', String(groupId));
  const s = p.toString();
  return s ? `?${s}` : '';
}

export function useNotifications(options: QueryOptions, groupId?: number) {
  return useQuery({
    queryKey: ['admin', 'notifications', options, groupId ?? null],
    queryFn: () => apiClient.get<PagedResult<ThresholdNotificationDto>>(`/api/admin/notifications${toQuery(options, groupId)}`)
  });
}

/** Queue a threshold evaluation now; the runner emails anything newly crossed. */
export function useEvaluateThresholds() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => apiClient.post<JobEnqueueResultDto>('/api/admin/notifications/evaluate', {}),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin'] })
  });
}
